/**
 * Created by liuxi on 2018/3/17.
 */

export function pagination() {
  return {
    pageNum: 1,
    pageSize: 10,
    pageNo: 1,
    total: 0,
    pageList: [10, 20, 30, 50]
  }
}
